/**
 *	Base class - all Api request
 */
import Component from "./component";

export default class ApiRequests extends Component {
  constructor() {
    super();
  }

  /** Request to PDLIST check the product is inside warranty or outside warranty **/
  checkWarranty() {
    var $this = this;
    $this.errorCode = "";
    var form = new FormData();
    var productType = $.trim($("#product-type").val());
    var model = $.trim($("#model").val());
    var serial = $.trim($("#serial").val());
    var imeiNumber = $.trim($("#imei-number").val());
    var recaptchaResponse = $.trim($("#recaptchaResponse").val());

    var productCode = site === 'ie' ? $this.getProductCodeForProductTypeIE(productType) : $this.getProductCodeForProductType(productType);
    /* $this.deviceDetails.productType = productCode;
        $this.deviceDetails.serviceType = this.serviceType;
        $this.deviceDetails.subServiceType = this.subServiceType;*/

    // answers ...
    form.append("productCode", productCode);
    form.append("modelCode", model);
    form.append("serialNo", serial);

    if (imeiNumber !== "" ) {
         form.append("imeiNo", imeiNumber);
    }

    form.append("caseID", $this.lucidRef);
    form.append("tsRef", $this.tsRef);
    form.append("recaptchaResponse", recaptchaResponse);

    for (var value of form.values()) {
      $this.doLog(value);
    }

    var url = $this.host + $this.path + "igspn-pdlist-v2.php";

    var settings = {
      url: url,
      data: form,
      processData: false,
      contentType: false,
      dataType: "json",
      type: "POST",
    };

    $.ajax(settings)
      .done(function (response) {
        $this.doLog(response);
        $(".lds-ring").hide();
        $this.isRequestToPdListSent = true;

        if (response.success) {
          $this.doLog("PD List success");
          $this.setServiceTypeByProductCode(response);

          if ($this.isIMEINumberRequired) {
            $this.isValidPdListIMEINumber = true;
          } else if ($this.isSerialNumberRequired) {
            $this.isValidPdListSerialNumber = true;
          } else if ($this.isModelNumberRequired) {
            $this.isValidPdListModelNumber = true;
          }

          if (typeof ga === "function") {
            ga("create", $this.gaId, {
              name: "gtm9995",
              cookieExpires: "33696000",
              cookieDomain: "auto",
            });
          }

          // Check openSO from response, if openSO not empty, then a pending ticket exists with the same unit
          // So we can show the error message to the user with error code 478
          // If we allow the user to continue the Journey at the time of Socreate we get the response with error code 478

          if (
            $.inArray(response.svcProductGroup2, $this.subProductGroup2) == -1
          ) {
            if ($this.isIMEINumberRequired) {
              $("#imei-number").trigger("input");
              $this.isValidPdListIMEINumber = false;
            } else if ($this.isSerialNumberRequired) {
              $("#serial").trigger("input");
              $this.isValidPdListSerialNumber = false;
            }

            //  $this.updateRecaptchaResponse('contact', 'recaptchaResponse');

            //  console.log('Product missmatch');
          } else if (response.openSO != "") {
            console.log("Selected service" + window.state.selectedservice);

            // call a method in parent class to show error message
            $this.showPendingTicketExistMsg();

            if (typeof ga === "function") {
              ga("gtm9995.send", {
                hitType: "event",
                eventCategory: "repair",
                eventAction: "booking",
                eventLabel: "Pdlist Pending ticket exits",
              });
            }
          } else if (
            response.reDo == "Y" &&
            window.state.selectedservice != "BESPOKE"
          ) {
            // call a method in parent class to show error message
            $this.showRepeatRequestMsg();

            if (typeof ga === "function") {
              ga("gtm9995.send", {
                hitType: "event",
                eventCategory: "repair",
                eventAction: "booking",
                eventLabel: "Pdlist Repeat request with in 90 days",
              });
            }
          } else if (
            window.state.selectedservice == "BESPOKE" &&
            !$this.isValidBespokeModelCode(response.modelCode)
          ) {
            $this.showBespokeWrongIMEINumberMsg();
          } else {
            $this.processPdListResponse(response);

            if (typeof ga === "function") {
              ga("gtm9995.send", {
                hitType: "event",
                eventCategory: "repair",
                eventAction: "booking",
                eventLabel: "Pdlist success",
              });
            }
          }
        } else {
          //console.log('Inside else');

          //console.log(response.headerCode, response.bodyCode);
          //console.log(response.headerCode == "202"  && response.bodyCode == "810");

          /** Too many attempts **/
          //if (response.headerCode == "202"  && ( response.bodyCode == "403" || response.bodyCode == "406" || response.bodyCode == "407" )) {
          if (response.headerCode == "202" && response.bodyCode == "403") {
            // call a method in parent class to show error message
            $this.showTooManyAttemptsMsg(response.bodyCode);

            if (typeof ga === "function") {
              ga("gtm9995.send", {
                hitType: "event",
                eventCategory: "repair",
                eventAction: "booking",
                eventLabel: "Pdlist too many attempts",
              });
            }
          } /** Lucid ref is empty **/ else if (
            response.headerCode == "202" &&
            response.bodyCode == "400"
          ) {
            // call a method in parent class to show error message
            $this.showTooManyAttemptsMsg(response.bodyCode);

            if (typeof ga === "function") {
              ga("gtm9995.send", {
                hitType: "event",
                eventCategory: "repair",
                eventAction: "booking",
                eventLabel: "No Lucid Ref",
              });
            }
          } /** Model cannot be identified from SN or IMEI . Manual Model input required **/ else if (
            response.headerCode == "202" &&
            response.bodyCode == "807"
          ) {
            $this.isModelNumberRequired = true;
            $this.isRequestToPdListSent = false;
            $("#model-row").show();
            $("#model").trigger("input");
            //$('#pdlist-error .c-error').text(response.bodyCodeDesc);
            //$('#pdlist-error').show();
          } /** Invalid IMEI number **/ else if (
            response.headerCode == "202" &&
            response.bodyCode == "804"
          ) {
            $this.errorCode = 804;
            //The imei number entered is not valid. Please check you have entered the correct serial number.
            $this.triggerEvent();
          } /** Product purchased in Non UK or EU country **/ else if (
            response.headerCode == "202" &&
            response.bodyCode == "805"
          ) {
            $this.errorCode = 805;
            //It appears your product was not purchased in the UK or EU. Please visit the relevant Samsung website where you purchased your product for further assistance.
            $this.triggerEvent();
          } /** Serial number number entered is not valid **/ else if (
            response.headerCode == "202" &&
            response.bodyCode == "810"
          ) {
            $this.errorCode = 810;
            //The serial number entered is not valid. Please check you have entered the correct serial number e.g. try changing the letter ‘O' to zero ‘0'.
            $("#serial").trigger("input");
            $this.isValidPdListSerialNumber = false;
          } /** Model number entered is not valid **/ else if (
            response.headerCode == "202" &&
            response.bodyCode == "808"
          ) {
            $this.errorCode = 808;
            //The model number entered is not valid. Please check you have entered the correct model number e.g. try changing the letter ‘O' to zero ‘0'.
            $("#model").trigger("input");
            $this.isValidPdListModelNumber = false;
          } else {
            $this.triggerEvent();
          }

          if (typeof ga === "function") {
            ga("create", $this.gaId, {
              name: "gtm9996",
              cookieExpires: "33696000",
              cookieDomain: "auto",
            });
            ga("gtm9996.send", {
              hitType: "event",
              eventCategory: "repair",
              eventAction: "booking",
              eventLabel: "pd list fail",
            });
          }

          // $this.updateRecaptchaResponse('contact', 'recaptchaResponse');

          $this.doLog("PD List fail");
        }
      })
      .fail(function () {
        $this.doLog("PD List request error");

        if (typeof ga === "function") {
          ga("create", $this.gaId, {
            name: "gtm9997",
            cookieExpires: "33696000",
            cookieDomain: "auto",
          });
          ga("gtm9997.send", {
            hitType: "event",
            eventCategory: "repair",
            eventAction: "booking",
            eventLabel: "pd list broken end point",
          });
        }
      });
  }

  triggerEvent() {
    var $this = this;

    if ($this.isModelNumberRequired) {
      $("#model").trigger("input");
      $this.isValidPdListModelNumber = false;
    } else if ($this.isIMEINumberRequired) {
      $("#imei-number").trigger("input");
      $this.isValidPdListIMEINumber = false;
    } else if ($this.isSerialNumberRequired) {
      $("#serial").trigger("input");
      $this.isValidPdListSerialNumber = false;
    }
  }

  isValidBespokeModelCode(model) {
    let bespokeModelCodes = [
      "SM-F711B1BFEUA",
      "SM-F711B1CFEUA",
      "SM-F711B1DFEUA",
      "SM-F711B1EFEUA",
      "SM-F711B1FFEUA",
      "SM-F711B1GFEUA",
      "SM-F711B1HFEUA",
      "SM-F711B1IFEUA",
      "SM-F711B1JFEUA",
      "SM-F711B1KFEUA",
      "SM-F711B1LFEUA",
      "SM-F711B1MFEUA",
      "SM-F711B1NFEUA",
      "SM-F711B1OFEUA",
      "SM-F711B1PFEUA",
      "SM-F711B1QFEUA",
      "SM-F711B1RFEUA",
      "SM-F711B1SFEUA",
      "SM-F711B1TFEUA",
      "SM-F711B1UFEUA",
      "SM-F711B1VFEUA",
      "SM-F711B1WFEUA",
      "SM-F711B1XFEUA",
      "SM-F711B1YFEUA",
      "SM-F711B4AFEUA",
      "SM-F711B4BFEUA",
      "SM-F711B4CFEUA",
      "SM-F711B4DFEUA",
      "SM-F711B4EFEUA",
      "SM-F711B4FFEUA",
      "SM-F711B4GFEUA",
      "SM-F711B4HFEUA",
      "SM-F711B4IFEUA",
      "SM-F711B4JFEUA",
      "SM-F711B4KFEUA",
      "SM-F711B4LFEUA",
      "SM-F711B4MFEUA",
      "SM-F711B4NFEUA",
      "SM-F711B4OFEUA",
      "SM-F711B4PFEUA",
      "SM-F711B4QFEUA",
      "SM-F711B4RFEUA",
      "SM-F711B4SFEUA",
      "SM-F711B4TFEUA",
      "SM-F711B4UFEUA",
      "SM-F711B4VFEUA",
      "SM-F711B4WFEUA",
      "SM-F711B4XFEUA",
      "SM-F711B4YFEUA",
      "SM-F721B1SHEUB",
      "SM-F721B1THEUB",
      "SM-F721B1XHEUB",
      "SM-F721B1YHEUB",
      "SM-F721B2BHEUB",
      "SM-F721B2CHEUB",
      "SM-F721B2DHEUB",
      "SM-F721B2EHEUB",
      "SM-F721B2FHEUB",
      "SM-F721B2GHEUB",
      "SM-F721B2HHEUB",
      "SM-F721B2IHEUB",
      "SM-F721B2JHEUB",
      "SM-F721B2KHEUB",
      "SM-F721B2LHEUB",
      "SM-F721B2MHEUB",
      "SM-F721B2NHEUB",
      "SM-F721B2OHEUB",
      "SM-F721B2PHEUB",
      "SM-F721B2QHEUB",
      "SM-F721B2RHEUB",
      "SM-F721B2UHEUB",
      "SM-F721B2VHEUB",
      "SM-F721B2WHEUB",
      "SM-F721B4THEUB",
      "SM-F721B4XHEUB",
      "SM-F721B4YHEUB",
      "SM-F721B5AHEUB",
      "SM-F721B5BHEUB",
      "SM-F721B5CHEUB",
      "SM-F721B5DHEUB",
      "SM-F721B5EHEUB",
      "SM-F721B5FHEUB",
      "SM-F721B5HHEUB",
      "SM-F721B5IHEUB",
      "SM-F721B5JHEUB",
      "SM-F721B5KHEUB",
      "SM-F721B5LHEUB",
      "SM-F721B5MHEUB",
      "SM-F721B5NHEUB",
      "SM-F721B5OHEUB",
      "SM-F721B5PHEUB",
      "SM-F721B5QHEUB",
      "SM-F721B5RHEUB",
      "SM-F721B5UHEUB",
      "SM-F721B5VHEUB",
      "SM-F721B5WHEUB",
      "SM-F721B7AHEUB",
      "SM-F721B7BHEUB",
      "SM-F721B7CHEUB",
      "SM-F721B7DHEUB",
      "SM-F721B7EHEUB",
      "SM-F721B7FHEUB",
      "SM-F721B7GHEUB",
      "SM-F721B7HHEUB",
      "SM-F721B7IHEUB",
      "SM-F721B7JHEUB",
      "SM-F721B7KHEUB",
      "SM-F721B7LHEUB",
      "SM-F721B7MHEUB",
      "SM-F721B7NHEUB",
      "SM-F721B7OHEUB",
      "SM-F721B7PHEUB",
      "SM-F721B7QHEUB",
      "SM-F721B7RHEUB",
      "SM-F721B7SHEUB",
      "SM-F721B7THEUB",
      "SM-F721B7UHEUB",
      "SM-F721B7VHEUB",
      "SM-F721B7WHEUB",
      "SM-F721B2AHEUB",
      "SM-F721B4SHEUB",
      "SM-F721B5GHEUB",
      "SM-F721B7XHEUB",
      "SM-F721B7YHEUB",
      "SM-F721BLVHEUB",
    ];

    /*let bespokeModelCodesForTest = [
        "SM-F711BZKEEUA","SM-F711BZGAEUA","SM-F711BZKAEUA","SM-F711BZEAEUA","SM-F711BZEEEUA","SM-F711BZGAEUA","SM-F711BZKAEUA","SM-F711BLVEEUA",
        "SM-F711BZKEEUA","SM-F711BZKEEUA","SM-G920FZBEBTU"
        ]*/

    let bespokeModelCodesForTest = ["SM-G920FZBEBTU"];

    //if($.inArray(model, bespokeModelCodes) != -1 || $.inArray(model, bespokeModelCodesForTest) != -1) {
    if ($.inArray(model, bespokeModelCodes) != -1) {
      return true;
    } else {
      return false;
    }
  }

  updateRecaptchaResponse(action, elemId) {
    var $this = this;

    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LfPT-AZAAAAAG8HAnGL_wc1HiQ5oaaG7SJRYGx2", { action: action })
        .then(function (token) {
          var recaptchaResponse = document.getElementById(elemId);
          recaptchaResponse.value = token;
          $this.checkWarranty();
        });
    });
  }

  setServiceTypeByProductCode(response) {
    var $this = this;

    var productCode = response.productCode;

    /** Override default values from PDList response **/
    this.productCode = productCode;

    /** Please refer the SEUK online Journey API-Samples-Error V23 inside the doc folder for
        Product code to ServiceType mapping **/

    switch (productCode) {

      case "HHP":
        /** For Instore repair different service type **/
        if (window.state.selectedservice != "ISR") {
          this.serviceType = "PS";
          this.subServiceType = "LO";
        } else {
          this.serviceType = "CI";
          this.subServiceType = "";
        }
        this.thankyouPageVideo = "H1UECEqQUWk";
        break;

      case "HKE":
      case "REF":
      case "WSM":
        this.serviceType = "IH";
        this.subServiceType = "";
        this.thankyouPageVideo = "-ABKlRBjd8U";
        break;

      case "VDE":
        var subProductGroup = response.svcProductGroup;
        var subProductGroup2 = response.svcProductGroup2;
        var modelcode = response.modelCode;

        if (window.state.selectedservice == "KISS") {
          this.serviceType = "IH";
          this.subServiceType = "";
          this.thankyouPageVideo = "-ABKlRBjd8U";
        } else if (
          subProductGroup == "PJT03" ||
          subProductGroup2 == "LTV01" ||
          subProductGroup2 == "LTV02" ||
          subProductGroup2 == "LTV03" ||
          subProductGroup2 == "LTV04" ||
          subProductGroup2 == "LTV05" ||
          subProductGroup2 == "LTV06"
        ) {
          this.serviceType = "PS";
          this.subServiceType = "AP";
          this.thankyouPageVideo = "H1UECEqQUWk";
          window.state.selectedservice = "PSTVDA";
        } else {
          this.serviceType = "IH";
          this.subServiceType = "";
          this.thankyouPageVideo = "-ABKlRBjd8U";
          window.state.selectedservice = "IHTVDA";
          window.state._availableservice = "IHTVDA";
        }

        break;

      case "VEE":
        var subProductGroup2 = response.svcProductGroup2;
        if (window.state.selectedservice == "KISS") {
          this.serviceType = "IH";
          this.subServiceType = "";
          this.thankyouPageVideo = "-ABKlRBjd8U";
        } 
        else if (subProductGroup2 == "HTS02" || subProductGroup2 == "HTS01") {
          this.serviceType = "PS";
            this.subServiceType = "AP";
            this.thankyouPageVideo = "-H1UECEqQUWk";
            window.state.selectedservice = "PSTVDA";
            window.state._availableservice = "PSTVDA";
        } 
        else {
          this.serviceType = "PS";
          this.subServiceType = "";
          this.thankyouPageVideo = "H1UECEqQUWk";
          window.state.selectedservice = "PS";
        }
        //  else if (subProductGroup2 == "HTS01" || subProductGroup2 == "BRP01") {
        //   this.serviceType = "PS";
        //   this.subServiceType = "AP";
        //   this.thankyouPageVideo = "H1UECEqQUWk";
        //   window.state.selectedservice = "PS";
        // } else if (subProductGroup2 == "HTS02") {
        //   this.serviceType = "IH";
        //   this.subServiceType = "";
        //   this.thankyouPageVideo = "-ABKlRBjd8U";
        //   window.state.selectedservice = "IH";
        // }

        break;
      case "CLE":
        var subProductGroup = response.svcProductGroup;

        if (subProductGroup == "SVC03") {
          // if Site is IE
          if (site === 'ie') {
            this.serviceType = "PS";
            this.subServiceType = "AP";
            this.thankyouPageVideo = "-ABKlRBjd8U";
            window.state.selectedservice = "PSTVDA";
          } else {
            this.serviceType = "PS";
            this.subServiceType = "LO";
            this.thankyouPageVideo = "-ABKlRBjd8U";
            window.state.selectedservice = "PSTVDA";
          }
          
        } else {
          // if Site is IE
          if (site === 'ie') {
            this.serviceType = "PS";
            this.subServiceType = "AP";
            this.thankyouPageVideo = "H1UECEqQUWk";
            window.state.selectedservice = "PSTVDA";
          } else {
            this.serviceType = "PS";
            this.subServiceType = "LO";
            this.thankyouPageVideo = "H1UECEqQUWk";
            window.state.selectedservice = "PSTVDA";
          }
        }

        break;

      case "MON":
        var subProductGroup2 = response.svcProductGroup2;

        var monitorSmallPG = ["LMN01", "LMN02", "LMN03"];
        var monitorLargePG = ["LMN04", "LMN05", "LMN06"];

        if ($.inArray(subProductGroup2, monitorSmallPG) != -1) {
          this.serviceType = "PS";
          this.subServiceType = "AP";
          this.thankyouPageVideo = "H1UECEqQUWk";
          window.state.selectedservice = "PS";
        } else if ($.inArray(subProductGroup2, monitorLargePG) != -1) {
          this.serviceType = "PS";
          this.subServiceType = "AP";
          this.thankyouPageVideo = "-ABKlRBjd8U";
          window.state.selectedservice = "PS";
        }

        break;
    }

    $this.deviceDetails.productType = this.productCode;
    $this.deviceDetails.serviceType = this.serviceType;
    $this.deviceDetails.subServiceType = this.subServiceType;

    if (window.state.selectedservice == "KISS") {
      $this.deviceDetails.serviceType = "IH";
      $this.deviceDetails.subServiceType = "KS";
      this.thankyouPageVideo = "-ABKlRBjd8U";
    }

    $this.doLog("tsoutcome= " + window.state.tsoutcome.outcome);
    $this.doLog("productCode= " + $this.deviceDetails.productType);
    $this.doLog("serviceType= " + $this.deviceDetails.serviceType);
    $this.doLog("subServiceType= " + $this.deviceDetails.subServiceType);
  }

  processPdListResponse(response) {
    var $this = this;

    //$this.isProductInWarranty = $this.checkProductInWarranty(response.inOutWty);

    $this.symptoms = response.symptoms;
    /** Accessed from Parent class **/
    $this.showWarranty(response);
  }

  /*checkProductInWarranty(inOutWty) {

        var isProductInWarranty = "";

        switch (inOutWty) {

            case "LP":
            case "L":
            case "P":
                isProductInWarranty = true;
                break;

            case "OW":
            default:
                isProductInWarranty = false;
                break;

        }

        return isProductInWarranty;

    }*/

  getProductCodeForProductType(productType) {
    this.productCode = "";
    this.subProductGroup2 = "";
    this.serviceType = "";
    this.subServiceType = "";

    switch (productType) {
      case "Smartphones":
        this.productCode = "HHP";
        this.subProductGroup2 = ["CPH01", "CPH04", "CPH06"];
        if (window.state.selectedservice != "ISR") {
          this.serviceType = "PS";
          this.subServiceType = "LO";
        } else {
          this.serviceType = "CI";
          this.subServiceType = "";
        }
        break;

      case "Tablets":
        this.productCode = "HHP";
        this.subProductGroup2 = ["TAB01", "TAB02"];
        if (window.state.selectedservice != "ISR") {
          this.serviceType = "PS";
          this.subServiceType = "LO";
        } else {
          this.serviceType = "CI";
          this.subServiceType = "";
        }
        break;

      case "Wearables":
        this.productCode = "HHP";
        this.subProductGroup2 = ["CPH01", "WAT01", "BUD01", "RNG01"];
        if (window.state.selectedservice != "ISR") {
          this.serviceType = "PS";
          this.subServiceType = "LO";
        } else {
          this.serviceType = "CI";
          this.subServiceType = "";
        }
        break;
      case "Galaxy Book":
        this.productCode = "HHP";
        this.subProductGroup2 = ["TAB03", "NPC01"];
        if (window.state.selectedservice != "ISR") {
          this.serviceType = "PS";
          this.subServiceType = "LO";
        } else {
          this.serviceType = "CI";
          this.subServiceType = "";
        }
        break;

      case "TV":
        this.productCode = "VDE";
        this.subProductGroup2 = [
          "LTV01",
          "LTV02",
          "LTV03",
          "LTV04",
          "LTV05",
          "LTV06",
          "LTV07",
          "LTV43",
        ];
        this.serviceType = "PS";
        this.subServiceType = "";
        break;
      case "Projector":
        this.productCode = "VDE";
        this.subProductGroup2 = ["PJT03", "PJT01", "PRJ03", "PRJ01"];
        if (window.location.host != "www.samsung.com") {
          this.subProductGroup2.push("");
        }
        this.serviceType = "";
        this.subServiceType = "";
        break;
      case "AV":
        this.productCode = "VEE";
        this.subProductGroup2 = ["HTS01", "HTS02", "HTS03", "BRP01"];
        this.serviceType = "PS";
        this.subServiceType = "AP";
        break;
      case "Refrigerator":
        this.productCode = "REF";
        this.subProductGroup2 = ["REF01"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Laundry":
        this.productCode = "WSM";
        this.subProductGroup2 = ["WSM01", "WSD01", "AEWD1"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Dishwasher":
      case "Dishwashers":
        this.productCode = "HKE";
        this.subProductGroup2 = ["DHW01"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Microwave":
        this.productCode = "HKE";
        this.subProductGroup2 = ["MWO01"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Oven":
        this.productCode = "HKE";
        this.subProductGroup2 = ["ELO01"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Hob":
        this.productCode = "HKE";
        this.subProductGroup2 = ["ECT01"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Vacuum Cleaners":
        this.productCode = "CLE";
        this.subProductGroup2 = ["VCL01"];
        this.serviceType = "PS";
        this.subServiceType = "LO";
        break;
      case "Monitor":
        this.productCode = "MON";
        this.subProductGroup2 = [
          "LMN01",
          "LMN02",
          "LMN03",
          "LMN04",
          "LMN05",
          "LMN06",
        ];
        this.serviceType = "PS";
        this.subServiceType = "AP";
        break;
    }

    /*          case "Mobile phone":
            case "Smart Watch":
            case "Galaxy Buds":
            case "Tablet":
            case "Galaxy Book":
                this.productCode = "HHP";

                if (window.state.selectedservice != "ISR") {
                    this.serviceType = "PS";
                    this.subServiceType = "LO";
                } else {
                    this.serviceType = "CI";
                    this.subServiceType = "";
                }
                break;

            case "TV":
                this.productCode = "VDE";
                this.serviceType = "IH";
                this.subServiceType = "";
                break;
            case "Sound Bar":
                this.productCode = "VEE";
                this.serviceType = "PS";
                this.subServiceType = "AP";
                break;
            case "Blu-Ray":
                this.productCode = "VEE";
                this.serviceType = "PS";
                this.subServiceType = "AP";
                break;
            case "Refrigerator":
                this.productCode = "REF";
                this.serviceType = "IH";
                this.subServiceType = "";
                break;
            case "Washing Machine":
            case "Washer Dryer":
                this.productCode = "WSM";
                this.serviceType = "IH";
                this.subServiceType = "";
                break;
            case "Monitor":
                this.productCode = "MON";
                this.serviceType = "PS";
                this.subServiceType = "AP";
                break;
            case "Dishwasher":
            case "Microwave":
            case "Oven":
            case "Hob":
                this.productCode = "HKE";
                this.serviceType = "IH";
                this.subServiceType = "";
                break;
            case "Vacuum Cleaner":
                this.productCode = "CLE";
                this.serviceType = "PS";
                this.subServiceType = "AP";
                break;
            case "Tumble Dryer":
                this.productCode = "WSM";
                this.serviceType = "IH";
                this.subServiceType = "";
                break;*/

    return this.productCode;
  }


  // IE ProductType
  getProductCodeForProductTypeIE(productType) {
    this.productCode = "";
    this.subProductGroup2 = "";
    this.serviceType = "";
    this.subServiceType = "";

    switch (productType) {
      case "Smartphones":
        this.productCode = "HHP";
        this.subProductGroup2 = ["CPH01", "CPH04", "CPH06"];
        if (window.state.selectedservice != "ISR") {
          this.serviceType = "PS";
          this.subServiceType = "LO";
        } else {
          this.serviceType = "CI";
          this.subServiceType = "";
        }
        break;

      case "Tablets":
        this.productCode = "HHP";
        this.subProductGroup2 = ["TAB01", "TAB02"];
        if (window.state.selectedservice != "ISR") {
          this.serviceType = "PS";
          this.subServiceType = "LO";
        } else {
          this.serviceType = "CI";
          this.subServiceType = "";
        }
        break;

      case "Wearables":
        this.productCode = "HHP";
        this.subProductGroup2 = ["CPH01", "WAT01", "BUD01", "RNG01"];
        if (window.state.selectedservice != "ISR") {
          this.serviceType = "PS";
          this.subServiceType = "LO";
        } else {
          this.serviceType = "CI";
          this.subServiceType = "";
        }
        break;
      case "Galaxy Book":
        this.productCode = "HHP";
        this.subProductGroup2 = ["TAB03", "NPC01"];
        if (window.state.selectedservice != "ISR") {
          this.serviceType = "PS";
          this.subServiceType = "LO";
        } else {
          this.serviceType = "CI";
          this.subServiceType = "";
        }
        break;

      case "TV":
        this.productCode = "VDE";
        this.subProductGroup2 = [
          "LTV01",
          "LTV02",
          "LTV03",
          "LTV04",
          "LTV05",
          "LTV06",
          "LTV07",
          "LTV43",
        ];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Projector":
        this.productCode = "VDE";
        this.subProductGroup2 = ["PJT03", "PJT01", "PRJ03", "PRJ01"];
        if (window.location.host != "www.samsung.com") {
          this.subProductGroup2.push("");
        }
        this.serviceType = "";
        this.subServiceType = "";
        break;
      case "AV":
        this.productCode = "VEE";
        this.subProductGroup2 = ["HTS01", "HTS02", "HTS03", "BRP01"];
        this.serviceType = "PS";
        this.subServiceType = "AP";
        break;
      case "Refrigerator":
        this.productCode = "REF";
        this.subProductGroup2 = ["REF01"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Laundry":
        this.productCode = "WSM";
        this.subProductGroup2 = ["WSM01", "WSD01", "AEWD1"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Dishwasher":
      case "Dishwashers":
        this.productCode = "HKE";
        this.subProductGroup2 = ["DHW01"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Microwave":
        this.productCode = "HKE";
        this.subProductGroup2 = ["MWO01"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Oven":
        this.productCode = "HKE";
        this.subProductGroup2 = ["ELO01"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Hob":
        this.productCode = "HKE";
        this.subProductGroup2 = ["ECT01"];
        this.serviceType = "IH";
        this.subServiceType = "";
        break;
      case "Vacuum Cleaners":
        this.productCode = "CLE";
        this.subProductGroup2 = ["VCL01"];
        this.serviceType = "PS";
        this.subServiceType = "AP";
        break;
      case "Monitor":
        this.productCode = "MON";
        this.subProductGroup2 = [
          "LMN01",
          "LMN02",
          "LMN03",
          "LMN04",
          "LMN05",
          "LMN06",
        ];
        this.serviceType = "PS";
        this.subServiceType = "AP";
        break;
    }

    return this.productCode;
  }

  /** Request to PDLIST Ends here. **/

  /** Do repair Booking **/
  doRepairBooking() {
    var $this = this;
    var form = new FormData();

    var dateOfPurchase = "";

    if ($this.deviceDetails.dateOfPurchase != "") {
      var dateList = $this.deviceDetails.dateOfPurchase.split("/");
      dateOfPurchase = dateList[2] + dateList[1] + dateList[0];
    }

    if (window.state.proofOfPurchase) {
      if (window.state.proofOfPurchase.dateOfPurchase) {
        dateOfPurchase = window.state.proofOfPurchase.dateOfPurchase
      }
    }

    //$this.updateRecaptchaResponse('submit', 'recaptchaResponseSO');
    //var recaptchaResponse = $.trim($('#recaptchaResponseSO').val());

    var customerComment = $this.deviceDetails.issueNeedToFix;

    if (window.state.selectedservice == "ISR") {
      customerComment =
        $this.contactDetails.devicePickupOption + ", " + customerComment;
    }

    if (window.state.selectedservice == "BESPOKE") {
      customerComment =
        window.state.selectedFlipColour + ", " + customerComment;
    }

    if (window.state.selectedservice == "KISS") {
      customerComment =
        "Place of purchase:" +
        $this.deviceDetails.placeOfPurchaseText +
        ", " +
        customerComment;
    }

    var ubRepairPrice = "";

    // Upend the string "UBREPAIRREQUEST" to customer comment
    if (window.state.isUBPrice) {
      customerComment = " UBREPAIRREQUEST " + customerComment;
      ubRepairPrice = "Yes";
    }

    //console.log($this.deviceDetails);

    form.append("ubRepairPrice", ubRepairPrice);
    form.append("modelCode", $this.deviceDetails.model);
    form.append("serialNo", $this.deviceDetails.serial);
    form.append("imeiNo", $this.deviceDetails.imeiNumber);
    form.append("caseID", $this.deviceDetails.lucidRef);
    form.append("tsRef", $this.deviceDetails.tsRef);
    form.append("purchaseDate", dateOfPurchase);
    form.append("customerComment", customerComment);
    form.append("symptomCode1", $this.deviceDetails.symptoms1);
    form.append("symptomCode2", $this.deviceDetails.symptoms2);
    form.append("symptomCode3", $this.deviceDetails.symptoms3);
    form.append("wtyException", $this.deviceDetails.wtyException);
    form.append("serviceType", $this.deviceDetails.serviceType);
    form.append("subServiceType", $this.deviceDetails.subServiceType);
    form.append("dpdCollectionDate", $this.deviceDetails.collectionDate);
    form.append("placeOfPurchase", $this.deviceDetails.placeOfPurchase);

    if (
      window.state.selectedservice == "KISS" ||
      window.state.product == "TV" ||
      window.state.selectedservice == "IHTVDA" ||
      window.state.selectedservice == "PSTVDA"
    ) {
      form.append("appointmentDate", $this.deviceDetails.appointmentDate);
      form.append("appointmentTime", $this.deviceDetails.appointmentTime);
    }

    var samsungAccount = window.state.isUserLoggedIn
      ? window.state.userInfo.guid
      : "";
    form.append("samsungAccount", samsungAccount);
    // var customerBpNo =  '';
    // form.append('customerBpNo', customerBpNo);

    form.append("firstName", $this.contactDetails.firstName);
    form.append("lastName", $this.contactDetails.lastName);
    form.append("mobilePhone", $this.contactDetails.phone);
    form.append("homePhone", "");
    form.append("email", $this.contactDetails.email);
    form.append("region", $this.contactDetails.country);
    form.append("countryCode", $this.contactDetails.countryCode);
    form.append("postCode", $this.contactDetails.postcode);
    form.append("city", $this.contactDetails.town);
    form.append("address1", $this.contactDetails.address1);
    form.append("address2", $this.contactDetails.address2);
    form.append("address3", $this.contactDetails.address3);
    form.append("contactMobile", $this.contactDetails.contactbyPhone);
    form.append("contactEmail", $this.contactDetails.contactbyEmail);
    form.append("contactSMS", $this.contactDetails.contactbySMS);
    //form.append('recaptchaResponse', recaptchaResponse);

    // Log this detials on console only on local and QA environment
    if (window.location.host != "www.samsung.com") {
      for (var value of form.values()) {
        $this.doLog(value);
      }
    }

    if (
      window.state.product == "TV" ||
      window.state.selectedservice == "KISS"
    ) {
      var url = $this.host + $this.path + "igspn-socreate-tvkiss-v2.php";
    } else if (window.state.selectedservice == "ISR") {
      var url = $this.host + $this.path + "igspn-srcreate-v2.php";
    } else if (window.state.selectedservice == "BESPOKE") {
      var url = $this.host + $this.path + "igspn-socreate-bespoke-v2.php";
    } else {
      var url = $this.host + $this.path + "igspn-socreate-v2.php";
    }

    // var url = "http://repair-booking-qudini-server.samsung.com/igspn-socreate.php";

    var settings = {
      url: url,
      data: form,
      processData: false,
      contentType: false,
      type: "POST",
    };

    $.ajax(settings).done(function (response) {
      $this.doLog(response);

      $this.soCreateResponse = response;

      $this.showStep4();
    });
  }

  /** Do repair Booking ends here **/

  /* Proof of Purchase */

  doProofOfPurchase(soResponse) {
    var $this = this;
    var form = new FormData();

    form.append("caseID", $this.deviceDetails.lucidRef);
    form.append("serviceOrderNo", soResponse.serviceOrderNo);
    form.append("fileSize", window.state.proofOfPurchase.size);
    form.append("fileType", window.state.proofOfPurchase.type);
    form.append("imageData", window.state.proofOfPurchase.fileBase64);

    var url = $this.host + $this.path + "igspn-attachsave-v2.php";

    var settings = {
      url: url,
      data: form,
      processData: false,
      contentType: false,
      type: "POST",
    };

    $.ajax(settings).done(function (popResponse) {
      $this.doLog(popResponse);

      $this.soCreateResponsePOP = popResponse;

      $this.drawThankyouPage()
    });
  }
}
